<template>
  <div class="container-content login-content">
  </div>
</template>

<script>
export default {
  name: 'login',
  created () {
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {}
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/layout/login/index.vue